import { render } from "./IconGrid.vue?vue&type=template&id=524169f5"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "524169f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('524169f5', __exports__)) {
    api.reload('524169f5', __exports__)
  }
  
  module.hot.accept("./IconGrid.vue?vue&type=template&id=524169f5", () => {
    api.rerender('524169f5', render)
  })

}


export default __exports__